import { useBreadcrumb } from "features/breadcrumbs";
import ListarConsumo from "./components/ListarConsumo";

function ConsumoListagemPage() {
  useBreadcrumb([
    { name: "Financeiro" },
    {
      name: "Consumo de água, esgoto, energia e gás",
      url: "/financeiro/consumo",
    },
  ]);

  return <ListarConsumo />;
}

export default ConsumoListagemPage;
